import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { LoadType } from '@tencent/ark-service-interface';
export var getExtensionSafe = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(name) {
    var extensionService, message, extension;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          extensionService = window.__ARK_EXTENSION_SERVICE__;
          if (extensionService) {
            _context.next = 5;
            break;
          }
          message = '__ARK_EXTENSION_SERVICE__ is undefined, need to call createExtensionService before';
          console.error(message);
          throw new Error(message);
        case 5:
          _context.next = 7;
          return extensionService.scanAndHandleExtensions([{
            name: name,
            loadType: LoadType.EAGER
          }]);
        case 7:
          _context.next = 9;
          return extensionService.getExtension(name);
        case 9:
          extension = _context.sent;
          return _context.abrupt("return", extension);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getExtensionSafe(_x) {
    return _ref.apply(this, arguments);
  };
}();